import { useState, useEffect } from "react";
import styles from "./LoginForm.module.css";
import { useNavigate } from "react-router-dom";
import { getUrl } from "../App";
import getCSRFTokenFromCookie from "../utils/getCSRFToken";
const LoginForm = ({ route, method }) => {
  const [csrfToken, setCsrfToken] = useState((""));
  const navigate = useNavigate();
  const redirectUrl = window.location.origin;
  const keycloakRedirectUrl = `${getUrl()}/_allauth/browser/v1/auth/provider/redirect`;

  useEffect(() => {
    const retrieveCookie = async() => { 
    try {
      const response = await fetch(`${getUrl()}/csrf`,);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }
    setCsrfToken(getCSRFTokenFromCookie);
  } catch (error) {
    console.error(error.message);
  }
    }
    retrieveCookie();
}, []);

  

  return (
    <form method="POST" action={keycloakRedirectUrl} className={styles.form_container}>
      <h1 className={styles.login_header}>Login</h1>
      <input type="hidden" name="provider" value="keycloak"/>
      <input type="hidden" name="callback_url" value={redirectUrl} />

      <input type="hidden" name="process" value="login" />
      <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
      <button type="submit" className={styles.form_button}>
        🔑 Log in with Keycloak
      </button>
    </form>
  );
};

export default LoginForm;
